import get from './get';
import updateVideo from './updateVideo';
import updateTopBarInfo from './updateTopBarInfo';
import hideTopBarInfo from './hideTopBarInfo';

export default {
  get,
  updateVideo,
  updateTopBarInfo,
  hideTopBarInfo,
};



// WEBPACK FOOTER //
// ./src/app/services/configuration/index.js